import { Ref } from '@nuxtjs/composition-api';
import { getActiveCategory } from '@shared/composables/useUiHelpers';
import { IStoryblokShopifyCategory } from '@shared/types/storyblok';
import { Collection } from '@unified-commerce/gpc-vue-storefront-shopify';
import kebabCase from 'lodash.kebabcase';
import { Route } from 'vue-router';

import {
  CATEGORY_ROUTE_PREFIX,
  SEARCH_CATEGORY_TENANT_PREFIX_HANDLE,
  SEARCH_CATEGORY_TENANT_PREFIX_TITLE,
} from '~/constants';

export const getCategory = (
  route: Route | Ref<Route>,
  shopifyCategories: readonly Collection[],
): Collection | undefined => {
  const categoryHandleSuffix = getActiveCategory(route);
  const fullCategoryHandle = `${SEARCH_CATEGORY_TENANT_PREFIX_HANDLE}${categoryHandleSuffix}`;

  return shopifyCategories.find((shopifyCategory) => shopifyCategory.handle === fullCategoryHandle);
};

export const getCategoryCarouselLink = (category: IStoryblokShopifyCategory) => {
  const collectionTitle = Array.isArray(category.content?.product_category)
    ? category.content?.product_category?.[0]?.shopify_category?.items?.[0]?.name ?? ''
    : category.content?.product_category?.title;
  const path = collectionTitle
    .replace(`${SEARCH_CATEGORY_TENANT_PREFIX_TITLE}>`, '')
    .split('>')
    .map((segment) => kebabCase(segment))
    .join('/');
  return `/${CATEGORY_ROUTE_PREFIX}/${path}`;
};
